import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_229';

const stepsList = [
/*   { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Inmuebles Leasing', listHelp: ['158']}, */
  { text: "1", active: true, completed: false, tooltip: 'Lista de Bienes Inmuebles No Leasing', listHelp: ['323'] }
];

const tableStructure = [
    {id: 'pagador', title: 'Reportante'}, 
    {id: 'origen', title: 'Origen información'}, 
    {id: 'conceptoNombre', title: 'Concepto'}, 
    {id: 'valor', title: 'Valor'},
];


class Form1 {
  id: number;
  pagador: string;
  origen: string;
  concepto: string;
  conceptoNombre: string;
  valor: string;
  parteNoGravada: string;
  retencion:string;
  controlSugeridaForm: ControlSugeridaForm;
}
class ControlSugeridaForm{
  numNitReportante: string;
  grupos:Array<ControlGrupoVariables>;
}
class ControlGrupoVariables{
  idGrupo:number;
  variable:string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-ingresos-arrendamientos-modal',
  templateUrl: './ingresos-arrendamientos-modal.component.html',
  styleUrls: ['./ingresos-arrendamientos-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class IngresosArrendamientosModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public lstAnios: number[] = [];

  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave:boolean;
  tablaArt73:any;
  listaConceptosIng:any;
  model:DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<IngresosArrendamientosModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _componentFactory: ComponentFactoryService,
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    //this.model = this.data;
    console.log(this.model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    this.validateShowSave();
    console.log(this.model);

  }

  protected controlStep(direction: DirectionType): void {
  
  }
  

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.pagador="";
    this.modelForm.concepto="0";
    this.modelForm.valor="0";
    this.modelForm.parteNoGravada="0";
    this.modelForm.retencion="0";
    this.modelForm.origen="";

  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_324 == undefined){
      this.model.doc.cuerpo.cc_id_324 = []; //pagador
      this.model.doc.cuerpo.cc_id_326 = []; //concepto
      this.model.doc.cuerpo.cc_id_325 = []; //origen
      this.model.doc.cuerpo.cc_id_327 = []; //valor
      this.model.doc.cuerpo.cc_id_333 = []; //parte no gravada
      this.model.doc.cuerpo.cc_id_334 = []; //retencion
      this.model.doc.cuerpo.cs_id_328 = "0";
    }  
  }

  public reloadCifras(){
    if(this.modelForm.concepto != '5')
      this.modelForm.parteNoGravada = "0";
    
  }


  public operacionCs328(){ 
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valor, suma);
    }
    const sumaCs371 = this.obtenerSumaRentaCapital();
    this.model.doc.cuerpo.cs_id_328 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,suma, sumaCs371);
  
  }

  protected obtenerSumaRentaCapital(){
    let totalSum = "0";
    if(this.model.doc.cuerpo.cc_id_370 != undefined 
      && this.model.doc.cuerpo.cc_id_370 != null){
        const itemsRentaNoLaboral = this.model.doc.cuerpo.cc_id_370
        .filter(item => item.v === "3")
        .map(item => item.it);

        const valoresItemsRentaCapital = this.model.doc.cuerpo.cc_id_371
        .filter(item => itemsRentaNoLaboral.includes(item.it))
        .map(item => item.v);
      
        for(let i=0; i<valoresItemsRentaCapital.length; i++){
          totalSum = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,valoresItemsRentaCapital[i], totalSum);
        } 
    
    };
   
    return totalSum;
  }


  
  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_324.length; i++){
      this.modelForm.id=i;
      this.modelForm.pagador=this.model.doc.cuerpo.cc_id_324[i].v;
      this.modelForm.origen=this.model.doc.cuerpo.cc_id_325[i].v;
      this.modelForm.concepto=this.model.doc.cuerpo.cc_id_326[i].v;
      if(this.listaConceptosIng && this.listaConceptosIng.length>0)
        this.modelForm.conceptoNombre=this.listaConceptosIng[this.model.doc.cuerpo.cc_id_326[i].v-1].nombre;
      this.modelForm.valor=this.model.doc.cuerpo.cc_id_327[i].v;
      this.modelForm.parteNoGravada=this.model.doc.cuerpo.cc_id_333[i].v;
      this.modelForm.retencion=this.model.doc.cuerpo.cc_id_334[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

protected initializeTablaDesdeSugerida()
{
  let indexModel = this.model.doc.cuerpo.cc_id_324.length;

  if(indexModel==0){
    const fieldsRecovery = ['VAR_2005','VAR_2206','VAR_2477','VAR_2405','VAR_2213','VAR_3663','VAR_3664','VAR_5181','VAR_969','VAR_2409','VAR_970','VAR_4757','VAR_3826','VAR_1895 ','VAR_1267','VAR_4824','VAR_4069','VAR_4484','VAR_4485','VAR_5161','VAR_1732','VAR_1733','VAR_2072','VAR_2073','VAR_4488','VAR_973'];
    const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
    
    const grupos=[
      ['VAR_2005','VAR_2206','VAR_2477','VAR_2405','VAR_2213','VAR_3663','VAR_3664','VAR_5181','VAR_969','VAR_2409','VAR_970','VAR_4757','VAR_3826','VAR_1895 ','VAR_1267','VAR_4824','VAR_4069','VAR_4484','VAR_4485','VAR_5161'],
      ['VAR_1732','VAR_1733','VAR_2072','VAR_2073','VAR_4488','VAR_973']
    ];
  
    if(resData)
    {
      for(let i=0; i<resData.length; i++){
        for(let j=0; j<resData[i].item.value.length; j++){
            this.modelForm.id=indexModel;
            this.modelForm.pagador=resData[i].item.numNitInformante[j]+"/"+resData[i].item.nomRazonSocialInformante[j];
            
            this.modelForm.origen="0";
            if(resData[i].key=="VAR_2005" || resData[i].key=="VAR_2206" || resData[i].key=="VAR_2477" || resData[i].key=="VAR_2405" || resData[i].key=="VAR_3663"){
              this.modelForm.concepto= "1"; 
            }
            if(resData[i].key=="VAR_4484" || resData[i].key=="VAR_4485" || resData[i].key=="VAR_5161"){
              this.modelForm.concepto= "2"; 
            }
            if(resData[i].key=="VAR_2213" || resData[i].key=="VAR_3664" || resData[i].key=="VAR_5181" || resData[i].key=="VAR_969" || resData[i].key=="VAR_2409" || resData[i].key=="VAR_970" || resData[i].key=="VAR_4757"){
              this.modelForm.concepto= "4"; 
            }
            if(resData[i].key=="VAR_3826" || resData[i].key=="VAR_1895" || resData[i].key=="VAR_1267" || resData[i].key=="VAR_4824" || resData[i].key=="VAR_4069"){
              this.modelForm.concepto= "5"; 
            }
            if(this.listaConceptosIng[Number(this.modelForm.concepto)-1])
              this.modelForm.conceptoNombre= this.listaConceptosIng[Number(this.modelForm.concepto)-1].nombre;
            
            let itemGrupoFormPorEditar:Form1 = null;

            //0. Buscar el idGrupo al que corresponde la variable. (Siempre lo debe encontrar)
            let idGrupo:number = -1;
            for(let k=0;k<grupos.length;k++){
              if(grupos[k].includes(resData[i].key)){
                idGrupo=k;
                break;
              }
            }

            //1. El nit ya existe? NO ->1:Agregar
            if(this.dataSourceBody.find((el)=>{
              return el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]    
            })==undefined){
              itemGrupoFormPorEditar = null;
            }else{

              //2. Trae array de solo los del NIT
              let dataSourceBodyPorNitRep = this.dataSourceBody.filter((el)=>{
                if(el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]){
                  return el;
                }
              });

              //3. Recorrer array de solo los del NIT
              for(let k=0;k<dataSourceBodyPorNitRep.length;k++){
                //En el registro existe una variable del GRUPO? 
                //  - NO: Debe Editar el registro y deja de buscar
                //  - SI: Siga buscando (al final si todos tienen entonces debe Agregar nuevo registro por que esta todo ocupado)
                let dataGrupo = dataSourceBodyPorNitRep[k].controlSugeridaForm.grupos.find((el=>{return el.idGrupo==idGrupo}));
                if(!dataGrupo){
                  itemGrupoFormPorEditar = dataSourceBodyPorNitRep[k];
                  break;
                }
              }

            }
            
            //4. Si la variable 'itemGrupoFormPorEditar' tiene valor entonces EDITA, si no AGREGA
            if(itemGrupoFormPorEditar){
              this.dataSourceBody = this.dataSourceBody.filter((itemModelForm)=>{
                if(itemModelForm.id == itemGrupoFormPorEditar.id){
                  itemModelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
                  itemModelForm = this.asignarVariablesSugeridasCondicionadas(itemModelForm, idGrupo, String(resData[i].item.value[j]));
                }
                return itemModelForm;
              });
            }else{
              this.modelForm.controlSugeridaForm = new ControlSugeridaForm();
              this.modelForm.controlSugeridaForm.numNitReportante = resData[i].item.numNitInformante[j];
              this.modelForm.controlSugeridaForm.grupos = new Array<ControlGrupoVariables>();
              this.modelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
              this.redondearFormData();
              this.modelForm = this.asignarVariablesSugeridasCondicionadas(this.modelForm, idGrupo, String(resData[i].item.value[j]));
              this.dataSourceBody.push(this.modelForm);
              this.inicializeForm();
              indexModel++;
            }
        }
      }
      
    }
  }

    this.operacionCs328();
}

private asignarVariablesSugeridasCondicionadas(itemModelForm: Form1, idGrupo:number, valor:string){
  switch(idGrupo){//Depende de la variable array grupos
    case 0:
      itemModelForm.valor=String(valor);
    break;
    case 1:
      itemModelForm.retencion=String(valor);
    break;
    default:
    break;
  }
  return itemModelForm;
}

  public editModeloDesdeForm(){
   
    this.model.doc.cuerpo.cc_id_324[this.modelForm.id].v=this.modelForm.pagador;
    this.model.doc.cuerpo.cc_id_325[this.modelForm.id].v=this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_326[this.modelForm.id].v=this.modelForm.concepto.toString();
    this.model.doc.cuerpo.cc_id_327[this.modelForm.id].v=this.modelForm.valor.toString();
    this.model.doc.cuerpo.cc_id_333[this.modelForm.id].v=this.modelForm.parteNoGravada.toString();
    this.model.doc.cuerpo.cc_id_334[this.modelForm.id].v=this.modelForm.retencion.toString();

  }

  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_324.push({it: i, v:this.modelForm.pagador});
    this.model.doc.cuerpo.cc_id_325.push({it: i, v:this.modelForm.origen.toString()});
    this.model.doc.cuerpo.cc_id_326.push({it: i, v:this.modelForm.concepto.toString()});
    this.model.doc.cuerpo.cc_id_327.push({it: i, v:this.modelForm.valor.toString()});
    this.model.doc.cuerpo.cc_id_333.push({it: i, v:this.modelForm.parteNoGravada.toString()});
    this.model.doc.cuerpo.cc_id_334.push({it: i, v:this.modelForm.retencion.toString()});

  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_324.splice(index,1);
    this.model.doc.cuerpo.cc_id_325.splice(index,1);
    this.model.doc.cuerpo.cc_id_326.splice(index,1);
    this.model.doc.cuerpo.cc_id_327.splice(index,1);
    this.model.doc.cuerpo.cc_id_333.splice(index,1);
    this.model.doc.cuerpo.cc_id_334.splice(index,1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_324.length;i++){
      this.model.doc.cuerpo.cc_id_324[i].it=i+1;
      this.model.doc.cuerpo.cc_id_325[i].it=i+1;
      this.model.doc.cuerpo.cc_id_326[i].it=i+1;
      this.model.doc.cuerpo.cc_id_327[i].it=i+1;
      this.model.doc.cuerpo.cc_id_333[i].it=i+1;
      this.model.doc.cuerpo.cc_id_334[i].it=i+1;

    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.pagador==undefined || this.modelForm.pagador==null || this.modelForm.pagador.trim()=="" ||
        this.modelForm.concepto==undefined || this.modelForm.concepto==null  || this.modelForm.concepto=="0" || 
        this.modelForm.valor==undefined || this.modelForm.valor=='0' ||
        /* this.modelForm.parteNoGravada==undefined ||  (this.modelForm.concepto=="5" && this.modelForm.parteNoGravada=="0") ||    */
         this.modelForm.retencion==undefined || this.modelForm.retencion==null ||      
        this.modelForm.origen==undefined || this.modelForm.origen==null 
  }

  public redondearFormData(){
    this.modelForm.valor=this.dutilidades.redondearValorMoneda(this.modelForm.valor.toString(),true);
    this.modelForm.parteNoGravada=this.dutilidades.redondearValorMoneda(this.modelForm.parteNoGravada.toString(),true);
    this.modelForm.retencion=this.dutilidades.redondearValorMoneda(this.modelForm.retencion.toString(),true);

  }

  public calcularValoresForm(conservarArt?:boolean){
    this.redondearFormData();
  }

  validarParteNoGravada(){
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,this.modelForm.parteNoGravada,this.modelForm.valor)){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("La parte no gravada no puede ser mayor al valor" );
      this.modelForm.parteNoGravada="0";
    }

  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
     // this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla==this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla==this.OPERACION_EDITAR){
        this.modelForm.conceptoNombre = this.listaConceptosIng[Number(this.modelForm.concepto)-1].nombre;
        if(this.modelForm.origen=="0"){ 
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });

      }else if (this.operacionTabla==this.OPERACION_AGREGAR){ //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_324.length;
        this.modelForm.origen = "2";
      //  this.modelForm.reportante = "Contribuyente";
        this.modelForm.conceptoNombre = this.listaConceptosIng[Number(this.modelForm.concepto)-1].nombre;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs328();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs328();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
   
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }



  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs328();
    /* this.changeStepLocal(0); */
    this.dialogRef.close("");
  }
  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_324 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCs328();
    
    this.saveModel.emit(true);
    this.closeModal();
   
  }
  public borrarTabla(){
    this.dataSourceBody = [];
  }

  protected cleanInput(nameInput: string): void {
    if(this.modelForm[nameInput] == "0" || this.modelForm[nameInput] == "")
      this.modelForm[nameInput] = '';
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-arrendamientos/ingresos-arrendamientos-modal.component.ts